import React, { useState, useEffect } from 'react';
import { updateAuthor } from '../../api/server';

const EditAuthor = ({ initialData, onClose, onEditSuccess }) => {
  const [form, setForm] = useState({ name: '', is_active: false });
  const [error, setError] = useState('');

  // Prefill form dựa trên dữ liệu từ initialData khi modal mở
  useEffect(() => {
    if (initialData) {
      setForm({
        name: initialData.name || '',
        is_active: initialData.is_active
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedAuthor = await updateAuthor(initialData._id, form);
      alert('Tác giả đã được cập nhật thành công!');
      console.log('Tác giả cập nhật thành công:', updatedAuthor);
      // Gọi callback cập nhật state từ component cha
      if (onEditSuccess) onEditSuccess(updatedAuthor);
      if (onClose) onClose();
    } catch (err) {
      console.error('Có lỗi xảy ra khi cập nhật tác giả:', err);
      setError('Có lỗi xảy ra khi cập nhật tác giả');
    }
  };

  return (
    <div className="editPro-container">
      <h1>Chỉnh sửa tác giả</h1>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Tên tác giả:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={form.name}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="is_active">
            <input
              type="checkbox"
              id="is_active"
              name="is_active"
              checked={form.is_active}
              onChange={handleChange}
            />{' '}
            Active
          </label>
        </div>
        <button type="submit" className="btn btn-primary">
          Sửa Tác Giả
        </button>
      </form>
    </div>
  );
};

export default EditAuthor;
